/* eslint-disable react/jsx-no-duplicate-props */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Fab, TextField, Switch, MenuItem } from '@mui/material';
import toast from 'react-hot-toast';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import _ from 'lodash';
import * as Yup from 'yup';
import { ReactFormBuilder, ReactFormGenerator } from 'react-form-builder2';
import 'react-form-builder2/dist/app.css';
import './DynamicForm.css';

import { createSafalEventDynamicForm, getSafalEventBusinessForm } from '../../../../services/Service';
import { transformYupErrorsIntoArray } from '../../../../utils/fn';
import DynamicFormViewModal from './DynamicFormViewModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90vw',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  maxHeight: '95vh',
  overflow: 'auto',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  '@media (max-width: 640px)': {
    width: '95vw',
    height: '95vh',
    overflow: 'auto',
  },
};

export default function DynamicFormModal({ data, open, onClose, isDisplay, eventInfo }) {
  const [builderData, setBuilderData] = React.useState([]);
  const [rsvpFormTemplate, setRsvpFormTemplate] = React.useState([]);
  const [selectedTemplate, setSelectedTemplate] = React.useState('');
  const [isDisableAll, setIsDisableAll] = React.useState(false);
  const [viewModal, setViewModal] = React.useState({
    open: false,
    data: [],
  });

  const onCloseThis = (refetchFlag, resData) => {
    setIsDisableAll(false);
    setBuilderData([]);
    setSelectedTemplate('');
    onClose(refetchFlag, resData);
  };

  const handleClose = async (refetchFlag, directClose, resData) => {
    onCloseThis(refetchFlag, resData);
    // if (isDisplay) {
    //   onCloseThis(refetchFlag, resData);
    //   return;
    // }
    // if (directClose) {
    //   onCloseThis(refetchFlag, resData);
    //   return;
    // }

    // if (_.isEqual(updateFieldValue, fieldValue)) {
    //   onCloseThis(refetchFlag, resData);
    //   return;
    // }
    // const result = await Swal.fire({
    //   text: 'Are you sure you want to close this?',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes',
    //   appendTo: 'body',
    //   customClass: {
    //     container: 'my-swal', // Add a custom class for styling
    //   },
    //   onBeforeOpen: () => {
    //     // Set a higher zIndex for the Swal modal
    //     document.querySelector('.my-swal').style.zIndex = 999999;
    //   },
    // });

    // if (result.isConfirmed) {
    //   onCloseThis(refetchFlag, resData);
    // }
  };

  const fetchData = async () => {
    try {
      const res = await getSafalEventBusinessForm({ status: 'Active', page: 0 });
      if (res.status === 200) {
        setRsvpFormTemplate(res.data.data);
      }
    } catch (err) {
      console.log('fetchData error', err.message);
    }
  };
  React.useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async () => {
    setIsDisableAll(true);
    try {
      const payload = {
        element: builderData,
      };

      const res = await createSafalEventDynamicForm(payload);
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose(true, true, res.data?.data);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onUpdate = async () => {
    // setIsDisableAll(true);
    // setFieldValueError([]);
    // try {
    //   const payload = {
    //     ...fieldValue,
    //   };
    //   await validationSchema.validate(payload, { abortEarly: false, strict: false });
    //   const res = await updateSafalEventTodo({ ...payload, _id: data._id });
    //   if (res.status === 200) {
    //     toast.success(res.data.message);
    //     handleClose(true, true);
    //   }
    // } catch (err) {
    //   setFieldValueError(transformYupErrorsIntoArray(err));
    //   toast.error(err?.response?.data?.message || err.message);
    // } finally {
    //   setIsDisableAll(false);
    // }
  };
  const selectedTemplateData = rsvpFormTemplate.find((item) => item?._id === selectedTemplate);

  const onLoad = async (selectedTemplateDataX) => {
    setBuilderData(selectedTemplateDataX.element);
    return selectedTemplateDataX.element;
  };

  return (
    <>
      <Modal sx={{ zIndex: 345 }} open={open} onClose={handleClose}>
        <Box sx={style}>
          <Fab
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
            onClick={handleClose}
            size="small"
            color="primary"
            aria-label="add"
          >
            <CloseIcon />
          </Fab>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '32px',
              marginBottom: '12px',
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ fontSize: '24px', fontWeight: 700, color: '#3D71FF' }}>
              Invite Dynamic Form
            </Typography>
            {rsvpFormTemplate.length > 0 && (
              <div style={{ width: '250px' }}>
                <TextField
                  value={selectedTemplate}
                  onChange={(e) => {
                    setSelectedTemplate(e.target.value);
                  }}
                  select
                  fullWidth
                  label="Select from Template"
                  size="small"
                  variant="outlined"
                  disabled={isDisableAll}
                >
                  {rsvpFormTemplate.map((item, index) => (
                    <MenuItem key={index} value={item._id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}
          </div>
          <div id="DynamicFormDiv">
            <RSVPtem selectedTemplateData={selectedTemplateData} onLoad={onLoad} setBuilderData={setBuilderData} />
          </div>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              marginTop: '22px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <Button
                disabled={isDisableAll}
                onClick={() => {
                  setViewModal({
                    data: builderData,
                    open: true,
                  });
                }}
                sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                variant="contained"
              >
                Preview
              </Button>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '22px', alignItems: 'center' }}>
              <Button
                disabled={isDisplay ? false : isDisableAll}
                sx={{
                  backgroundColor: '#ff4842',
                  ':hover': { backgroundColor: '#d40700' },
                  color: 'white',
                  borderRadius: '30px',
                  textTransform: 'capitalize',
                }}
                onClick={handleClose}
                variant="contained"
              >
                Cancel
              </Button>
              {!isDisplay && data === null && (
                <Button
                  disabled={isDisableAll}
                  onClick={onSubmit}
                  sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                  variant="contained"
                >
                  Create
                </Button>
              )}
            </div>
          </div>
        </Box>
      </Modal>
      <DynamicFormViewModal
        open={viewModal.open}
        data={viewModal.data}
        onClose={() => {
          setViewModal({
            data: [],
            open: false,
          });
        }}
      />
    </>
  );
}

const RSVPtem = ({ selectedTemplateData, onLoad, setBuilderData }) => {
  if (selectedTemplateData)
    return (
      <ReactFormBuilder
        key={selectedTemplateData?._id}
        saveAlways
        onLoad={() => onLoad(selectedTemplateData)}
        data={selectedTemplateData?.element || []}
        onPost={(data) => {
          const task_data = data?.task_data || [];
          setBuilderData(task_data);
        }}
      />
    );
  return (
    <ReactFormBuilder
      key={'2'}
      saveAlways
      onPost={(data) => {
        const task_data = data?.task_data || [];
        setBuilderData(task_data);
      }}
    />
  );
};
